<template>
  <ConfirmDialog></ConfirmDialog>
  <ul class="clase-breadcrumb">
    <li>
      <a class="text-500 no-underline line-height-3 cursor-pointer"
        >Odontologia</a
      >
    </li>
    <li class="px-2">
      <i class="pi pi-angle-right text-500 line-height-3"></i>
    </li>
    <li>
      <span class="text-900 line-height-3">Configuración de WhatsApp</span>
    </li>
  </ul>
  <div class="surface-section px-4 py-5 md:px-12 lg:px-12">
    <Toast />
    <div
      class="flex align-items-start flex-column lg:justify-content-between lg:flex-row"
    >
      <div>
        <div class="font-medium text-3xl text-900">
          Administrar Configuración de WhatsApp
          <Badge size="xlarge" severity="success"> {{ totalRegistros }}</Badge>
        </div>
      </div>
      <div class="flex mt-3 lg:mt-0">
        <Button
          label="NUEVA CONFIGURACIÓN"
          v-if="'WhatsApp Crear' in auth.user.permissions"
          v-tooltip.top="'Nueva Configuración'"
          icon="pi pi-plus"
          class="p-button-info mr-2"
          @click="openNuevo"
        />
      </div>
    </div>
    <div class="mt-2">
      <DataTable
        ref="dtconfigwhatsapp"
        :value="whatsapp"
        :loading="cargando"
        dataKey="id"
        :paginator="true"
        :rows="10"
        :rowHover="true"
        :filters="buscar"
        class="p-datatable-sm"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        :rowsPerPageOptions="[10, 50, 100]"
        currentPageReportTemplate="Mostrando {first} de {last} de {totalRecords} registros"
        responsiveLayout="scroll"
        selectionMode="single"
        showGridlines
        @row-dblclick="editFrm($event.data)"
      >
        <template #header>
          <div
            class="flex flex-column md:flex-row md:justify-content-end md:align-items-end"
          >
            <span class="block mt-2 md:mt-0 p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="buscar['global'].value"
                placeholder="Buscar Medicos..."
              />
            </span>
          </div>
        </template>

        <template #loading>
          <div class="flex align-items-center justify-content-center">
            <ProgressSpinner />
          </div>
        </template>
        <template #empty>
          <span class="flex align-items-center justify-content-center p-invalid"
            >No existen Registros!</span
          ></template
        >
        <Column header="#">
          <template #body="slotProps">
            {{ 1 + slotProps.index }}
          </template>
        </Column>
        <Column field="nombre_sucursal" header="SUCURSAL">
          <template #body="{ data }">
            {{ data.nombre_sucursal }}
          </template>
        </Column>
        <Column field="horas_antes" header="HORAS ANTES"></Column>
        <Column field="template_name" header="TEMPLATE"></Column>
        <Column field="creado_por" header="REALIZADO POR"></Column>
        <Column field="estado" header="ESTADO">
          <template #body="{ data }">
            <span :class="'product-badge ' + claseEstado[data.estado]">
              {{ data.estado_texto }}
            </span>
          </template>
        </Column>
        <Column header="ACCIONES">
          <template #body="slotProps">
            <Button
              class="p-button-icon-only p-button-raised"
              v-tooltip.top="'Ver Acciones'"
              icon="pi pi-ellipsis-v"
              @click="$refs['menu' + slotProps.data.id].toggle($event)"
            />
            <Menu
              :ref="'menu' + slotProps.data.id"
              :popup="true"
              :model="acciones(slotProps.data)"
            >
            </Menu>
          </template>
        </Column>
      </DataTable>
    </div>
    <WhatsAppCreate
      :show="frmDialog"
      :whatsappnew="whatsappnew"
      :sucursales="sucursales"
      @closeModal="ocultarDialog"
      @actualizarListado="cargarFrm"
    >
    </WhatsAppCreate>
  </div>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import WhatsAppService from "@/service/WhatsAppService";
import { useAuth } from "@/stores";
import WhatsAppCreate from "@/module/whatsapp/WhatsAppCreate.vue";
import SucursalService from "@/service/SucursalService";

export default {
  components: {
    WhatsAppCreate,
  },
  data() {
    return {
      whatsapp: [],
      cargando: true,
      frmDialog: false,
      whatsappnew: {},
      buscar: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
      enviado: false,
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
      ],
      errors: {},
      totalRegistros: 0,
      claseEstado: ["status-outofstock", "status-instock"],
      sucursales: [],
    };
  },
  whatsappService: null,
  auth: null,
  sucursalService: null,
  created() {
    this.auth = useAuth();
    this.whatsappService = new WhatsAppService();
    this.sucursalService = new SucursalService();
  },
  mounted() {
    this.cargarFrm();
    this.carSucursales();
  },
  methods: {
    carSucursales() {
      this.sucursalService.getSucursalesAll().then((data) => {
        this.sucursales = data || [];
      });
    },
    acciones(datos) {
      let permisosUsuarioAuth = this.auth.user.permissions;
      return [
        {
          label: "Editar",
          disabled: "WhatsApp Editar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-pencil",
          command: () => {
            this.editFrm(datos);
          },
        },
        {
          label: "Eliminar",
          disabled: "WhatsApp Eliminar" in permisosUsuarioAuth ? false : true,
          icon: "pi pi-trash",
          command: () => {
            this.deleteFrm(datos.id);
          },
        },
      ];
    },
    deleteFrm(id) {
      this.$confirm.require({
        message: "¿Está seguro que desea eliminar el registro?",
        header: "Confirmación",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Si, deseo eliminar",
        rejectLabel: "No, cancelar",
        accept: () => {
          this.whatsappService.deleteFrm(id).then((response) => {
            if (response.success == true) {
              this.$toast.add({
                severity: "success",
                summary: "Éxito",
                detail: response.message,
                life: 3000,
              });
              this.cargarFrm();
            } else {
              this.$toast.add({
                severity: "error",
                summary: "Error",
                detail: response.message,
                life: 3000,
              });
            }
          });
        },
      });
    },
    cargarFrm() {
      this.cargando = true;
      this.whatsappService.getWhatsAppAll().then((data) => {
        this.whatsapp = data.whatsapp || [];
        this.cargando = false;
      });
    },
    openNuevo() {
      this.whatsappnew = {
        estado: { label: "Activo", value: 1 },
      };
      this.enviado = false;
      this.frmDialog = true;
    },
    ocultarDialog() {
      this.frmDialog = false;
      this.enviado = false;
    },
    editFrm(datos) {
      this.whatsappnew = {
        ...datos,
        estado: {
          label: datos.estado_texto,
          value: datos.estado,
        },
      };
      this.frmDialog = true;

      this.enviado = false;
    },
  },
  watch: {
    whatsapp() {
      this.totalRegistros = this.whatsapp.length;
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
.clase-breadcrumb {
  list-style-type: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-size: 1rem;
  font-weight: 500;
}
</style>
